/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const StickyNoteSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" width="1em" height="1em" fill="currentColor">
    <path d="M11.0833 1.75H2.91667C2.27325 1.75 1.75 2.27325 1.75 2.91667V11.0833C1.75 11.7267 2.27325 12.25 2.91667 12.25H7.58333C7.65995 12.2501 7.73583 12.2351 7.80661 12.2057C7.87739 12.1764 7.94167 12.1334 7.99575 12.0791L12.0791 7.99575C12.127 7.94602 12.1658 7.88814 12.1934 7.82483C12.2016 7.80733 12.2063 7.78925 12.2127 7.77058C12.2293 7.72177 12.2393 7.67096 12.2424 7.6195C12.2436 7.60725 12.25 7.59558 12.25 7.58333V2.91667C12.25 2.27325 11.7267 1.75 11.0833 1.75ZM2.91667 2.91667H11.0833V7H7.58333C7.42862 7 7.28025 7.06146 7.17085 7.17085C7.06146 7.28025 7 7.42862 7 7.58333V11.0833H2.91667V2.91667ZM8.16667 10.2585V8.16667H10.2585L8.16667 10.2585Z"/>
  </svg>
);

export const StickyNoteIcon = (props) => <Icon component={StickyNoteSvg} {...props} />;
